<template>
  <BlokkliProvider v-bind="blokkliProps">
    <div class="page">
      <DefaultSection v-if="!hideTitle" class="is-title">
        <Container>
          <h1 class="title is-size-2 has-text-weight-bold" :class="greyClass()">
            {{ title }}
          </h1>
        </Container>
      </DefaultSection>
      <template v-if="!hasSidebar">
        <div>
          <BlokkliField :list="paragraphs" name="field_content" />
        </div>
      </template>
      <template v-if="hasSidebar">
        <DefaultSection class="is-content">
          <Container>
            <div class="columns">
              <div class="column is-two-thirds-desktop">
                <ContactForm v-if="isContactForm" />
                <div>
                  <BlokkliField :list="paragraphs" name="field_content" />
                </div>
              </div>
              <div :class="offsetClass()" class="column">
                <BlokkliField
                  :list="sidebar"
                  name="field_sidebar"
                  field-list-type="sidebar"
                />
              </div>
            </div>
          </Container>
        </DefaultSection>
      </template>
    </div>
  </BlokkliProvider>
</template>

<script setup lang="ts">
import type { NodeFrontendPageFragment } from '#graphql-operations'

const props = defineProps<NodeFrontendPageFragment>()

// Provide color global
provide<string>('color', props.color ?? 'default')

const route = useRoute()

const hasSidebar = computed(() => props.sidebar && props.sidebar.length > 0)
const currentRoutePath = `${route.path}`
const isContactForm = computed(
  () => strpos(currentRoutePath, '/contact', 0) === 0,
)
const isTestimonial = computed(
  () => strpos(currentRoutePath, '/testimonials', 0) === 0,
)

function strpos(haystack: string, needle: string, offset: number) {
  const i = `${haystack}`.indexOf(needle, offset || 0)
  return i === -1 ? false : i
}

function offsetClass() {
  let offsetClass = ''
  if (isContactForm.value) {
    offsetClass = 'is-offset-1'
  }
  return offsetClass
}

function greyClass() {
  let greyClass = ''
  if (isTestimonial.value) {
    greyClass = 'has-text-grey-dark'
  }
  return greyClass
}
</script>

<style lang="scss">
.select,
.select select {
  width: 100%;
}
.message.is-success .message-body {
  color: $green;
}
</style>
